import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { AssetsJson } from "../../../DynamicFormsJson/MastersJSON/assets";
import { MyComponentWithIconProps } from "../../../components/Comman/IconButton";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { imageUrl } from "../../../config/Url";
import { noInternetMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

class AssetsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
    };
  }

  onClickViewPreview = (e, row) => {
    window.open(imageUrl + row, "_blank");
  };

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      const isOutletMappedToDistributor = localStorage.getItem(
        "isOutletMappedToDistributor"
      );
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: AssetsJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
          } else {
            this.setState({
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Name",
                  value:
                    data.data !== null && data.data.name !== null
                      ? data.data.name
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Desription",
                  value:
                    data.data !== null && data.data.description !== null
                      ? data.data.description
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Type",
                  value:
                    data.data !== null && data.data.type !== null
                      ? data.data.type == "0"
                        ? "Assets"
                        : "Parameter"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Type",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup value={data.data.type} row name="type">
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="Assets"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Parameter"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Image Mandatory",
                  value:
                    data.data !== null && data.data.imageMandatory !== null
                      ? data.data.imageMandatory == "0"
                        ? "No"
                        : "Yes"
                      : "",
                },
                // {
                //   xs: 12,
                //   sm: 6,
                //   md: 6,
                //   lg: 6,
                //   label: "Image Mandatory",
                //   value: (
                //     <Grid item xs={12} sm={12} md={12} lg={12} container>
                //       <FormControl component="fieldset">
                //         <RadioGroup
                //           value={data.data.imageMandatory}
                //           row
                //           name="imageMandatory"
                //         >
                //           <FormControlLabel
                //             value="0"
                //             control={<Radio disabled />}
                //             label="No"
                //           />
                //           <FormControlLabel
                //             value="1"
                //             control={<Radio disabled />}
                //             label="Yes"
                //           />
                //         </RadioGroup>
                //       </FormControl>
                //     </Grid>
                //   ),
                // },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Asset Image",
                  value:
                    data.data.image !== null ? (
                      <MyComponentWithIconProps
                        statusImage={VisibilityIcon}
                        sx={{ marginRight: "45px", align: "center" }}
                        color="primary"
                        fontSize="medium"
                        title="View"
                        onClick={(e) =>
                          this.onClickViewPreview(e, data.data.image)
                        }
                      />
                    ) : (
                      "-"
                    ),
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }
  render() {
    const { dynamicMasterData, DataToSet } = this.state;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Assets View"}
            fieldMeta={[]}
            apiBaseURL={AssetsJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
  showNotification,
  showLoador,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AssetsView);
